import {Component, OnInit} from '@angular/core';
import {MenuAsideService, SubheaderService} from '../../../core/_base/layout';
import {UserService} from '../../../provider/user.service';
import {ProductService} from '../../../provider/product.service';
import {Router} from '@angular/router';

@Component({
  selector: 'kt-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {

  constructor(private myService: ProductService,
              private menuAsideService: MenuAsideService,
              private userService: UserService,
              private subheaderService: SubheaderService,
              private router: Router) {
    this.menuAsideService.pathname$.next(window.location.pathname);
  }

  ngOnInit() {
    this.subheaderService.title$.next({title: 'App Information', desc: ''});
  }


  updateApp() {
    this.myService.postPushMobileData(this.userService.record_change$.getValue().app_hotel_id);
  }

  gotoDetail(number: number) {
    switch (number) {
      case 1:
        this.updateApp();
        break;
      case 5:
        this.router.navigate(['/activity/requests']);
        break;
      case 6:
        this.router.navigateByUrl('/analysis');

    }
  }
}
